module.exports = __webpack_public_path__ + "img/brand_logo_m.1b3b20b3.svg";